<template>
  <div>
    <ModalConfirm 
      modalId="paidModal" 
      :text="`Are you sure to Mark All as Paid this order?`"
      :center="true"
      @onClick="changeStatus"
    />
    <TableBasic :payload="payload" @onChange="changeParameter">
      <template v-slot:parent_order_id="{ data }">
        <div>
          <router-link
            :to="'/order/orders/' + data.id +'?detail=waiting_payment&type_order=order'"
            class="text-decoration-none fw-bold"
            style="color: #5e50a1"
          >
            {{ data.id }}
          </router-link>
        </div>
      </template>
      <template v-slot:seller_name="{ data }">
        <div>
          <span class="fw-bold mb-1"
            style="color: #5e50a1">{{ data.order_sellers.length > 1 ? `${data.order_sellers.length} Sellers` : data.order_sellers[0].seller_store_name }}</span>
        </div>
      </template>
      <template v-slot:actions="{ data }">
        <div class="d-flex">
          <div>
            <button type="button" class="btn btn-light text-danger fw-bold" data-bs-toggle="modal" @click="setData(data)"
              data-bs-target="#paidModal">
              Mark All As Paid
            </button>
          </div>
          <div class="ms-auto">
            <button class="btn" v-if="!data.additional_row" @click="data.additional_row = !data.additional_row">
              <font-awesome-icon icon="fa-solid fa-sort-down" class="mb-1 text-warning" />
            </button>
            <button class="btn mt-3 align-middle" v-if="data.additional_row"
              @click="data.additional_row = !data.additional_row">
              <font-awesome-icon icon="fa-solid fa-sort-up" class="mb-1 text-warning" />
            </button>
          </div>
        </div>
      </template>
      <template v-slot:created_date="{ value }">
        <div>
          {{ filters.dateFull(value) }}
        </div>
      </template>
      <template v-slot:payment_deadline="{ value }">
        <div class="fw-bold">
          {{ filters.dateFull(value) }}
        </div>
      </template>
      <template v-slot:total_order="{ data }">
        <div>
          {{ filters.rupiah(data.order_calculation_details[data.order_calculation_details.length-1].nominal) }}
        </div>
      </template>
      <template v-slot:child_order_id="{ data }">
        <div>
          <span class="text-black-50"> Child Order ID </span>
          <br />
          <span class="text-secondary fw-bold">{{ data.id  }}</span>
        </div>
      </template>
      <template v-slot:location_destination="{ data }">        
        <div v-if="data?.product_items?.length > 0">
          <font-awesome-icon icon="fa-solid fa-location-dot" class="pe-2 text-secondary" />
          <span class="fw-bold text-secondary">{{ data.location_destination.city }}</span>
          <br />
          <span class="text-black-50"> Shipment Cost </span>
          <br />
          <span class="fw-bold">{{ filters.rupiah(data.order_seller_pricing.shipment_cost) }}</span>
        </div>
      </template>
      <template v-slot:location_origin="{ data }">
        <div v-if="data?.product_items?.length > 0">
          <font-awesome-icon icon="fa-solid fa-location-dot" class="pe-2 text-secondary" />
          <span class="fw-bold text-secondary">{{ data.location_origin.city }}</span>
          <br />
        </div>
      </template>
      <template v-slot:product="{ data }">
        <div>
          <span class="fw-bold mb-1"
            style="color: #5e50a1">{{ data?.product_items?.length > 0 ? `${data.product_items.length} Products` : '' }}</span>
        </div>
      </template>
    </TableBasic>
  </div>
</template>

<script>
  import TableBasic from "@/components/TableBasic.vue";
  import ModalConfirm from "@/components/ModalConfirm.vue";
  export default {
    components: {
      TableBasic,
      ModalConfirm
    },
    data() {
      return {
        payload: {
          filter: true,
          filterLabel: "Filter by Created date",
          datepickerOption: {
            autoApply: true,
            timePicker: false,
          },
          header: [{
              key: "parent_order_id",
              label: "P.ORDER ID",
              class: "text-start",
            },
            {
              key: "buyer_name",
              label: "BUYER",
              class: "text-start",
            },
            {
              key: "seller_name",
              label: "SELLER",
              class: "text-start",
            },
            {
              key: "total_order",
              label: "TOTAL ORDER",
              class: "text-start",
              sort: true,
              sort_key: 'order_seller_pricing.total_payment'
            },
            {
              key: "created_date",
              label: "CREATED DATE",
              class: "text-start",
              sort: true,
              sort_key: 'created_date'
            },
            {
              key: "payment_deadline",
              label: "EXPIRY DATE",
              class: "text-start",
              sort: true,
              sort_key: 'payment_deadline'
            },
            {
              key: "actions",
              label: "ACTIONS",
              class: "text-start",
            },
          ],
          second_header: [{
              key: "child_order_id",
              label: "Child Order ID",
              class: "text-start",
            },
            {
              key: "location_destination",
              label: "",
              class: "text-start",
            },
            {
              key: "location_origin",
              label: "",
              class: "text-start",
            },
            {
              key: "product",
              label: "",
              class: "text-start",
            },
            {
              key: "",
              label: "",
              class: "",
            },
            {
              key: "",
              label: "",
              class: "",
            },
            {
              key: "",
              label: "",
              class: "",
            },
          ],
          value: [],
          totalRows: 1,
          checkbox: true,
          currentPage: 1,
          perPage: 10,
          pageOptions: [10, 20, 50, 100],
          totalItems: 0,
          pickItems: [],
          search: true,
          startDate: "",
          endDate: "",
          searchPlaceholder: "Parent/Child Order ID/Buyer/Seller",
          searchContainerStyle: { maxWidth: '235px' },
          sortBy: "",
          sortType: "",
        },
        filterValue: {},
        data : {},
      };
    },
    methods: {
      changeParameter(value) {
        this.payload.perPage = value.per_page;
        this.payload.currentPage = value.current_page;
        this.payload.sortType = value.sort_type
        this.payload.sortBy = value.sort_by
        this.payload.totalItems = value.pick_items ? value.pick_items.length : this.payload.totalItems
        
        this.searchInput = value.search;
        this.filterValue = value.filter;
        this.getData();
      },
      async getData() {
        let payload = {
          page: this.payload.currentPage,
          size: this.payload.perPage,
          status: ["SUBMITTED", "PAYMENT_WAITING"]
        };
        try{
          if (this.filterValue) {
            payload.date_start = this.filterValue.from;
            payload.date_end = this.filterValue.to;
          }

          if(this.payload.sortBy) payload.sort_by = this.payload.sortBy
          if(this.payload.sortType) payload.sort_type = this.payload.sortType

          if (this.searchInput != "") {
            payload.keyword = this.searchInput;
          }

          const response = await this.$store.dispatch("order/getAllOrder", payload);
          // handling looping second row (additional_row)
          if(response?.items?.length){
            this.payload.value = response?.items?.map(x=> ({...x, additional_data : x.order_sellers}))
          }else{
            this.payload.value = []
          }
          this.payload.totalRows = response.count;
        }catch(error){
          console.log("ERROR : ", error)
          this.$swal({
            title: error.response?.data ?.errorMessage || error.message,
            icon: "warning",
            timer: 2000,
          })
        }
      },
      setData(data){
        this.data = data
      },
      async changeStatus() {
        const payload = {
          "order_id": this.data.id,
          "payment_method": this.data.payment_method
        }
        try{
          await this.$store.dispatch("order/changeStatusOrder", payload)

          setTimeout(() => {
            this.showMessage = false
            /* https://pmtools.paxel.co/issues/244 disable auto redirect to next status, refresh table data only */
            // this.$router.push("/order/orders?status=Paid" )
            this.getData();
          }, 500);
        }catch(error){
          console.log("ERROR : ", error)
          this.$swal({
            title: error.response?.data ?.errorMessage || error.message,
            icon: "warning",
            timer: 2000,
          })
        }
      }
    },
    mounted() {
      this.getData();
    },
  };
</script>

<style></style>